module.exports = __webpack_public_path__ + "img/jt.897d02ed.png";